import { format } from "date-fns";
import { constants } from "@/utils/constants";
import { formatInTimeZone } from "@/helpers";

export default {
  getJobs: state => {
    switch (state.filter) {
      case "All":
        return state.hirejobs;
      case "All by 24 hr":
        return state.hirejobs.filter(job => {
          const createdOn = new Date(job.createdOn).getTime();
          const currentTime = new Date().getTime();
          const nextDay = new Date();
          nextDay.setHours(nextDay.getHours() + 24);

          return createdOn >= currentTime && createdOn <= nextDay.getTime();
        });
      case "All unapproved":
        return state.hirejobs.filter(job => job.status == 0);
      default:
        return state.hirejobs;
    }
  },
  getLocationFormatted: state => {
    const location = state.LocationForDispute[0] || {};
    return {
      stats: {
        ID: location.id,
        Status: location.Status,
        "Member since": location.registerTimestamp
          ? format(new Date(location.registerTimestamp), "MMMM do yyyy")
          : null,
        "Jobs Completed": location["Jobs Completed"],
        "# of Cancelled": `${location["# of cancelled"]} [${location["% of cancelled"]}%]`,
        "# of Rated Jobs": location["# of Rated Jobs"],
        "# of Ratings = 5": `${location["# of Ratings = 5"]} [${location["% of Ratings = 5"]}%] `,
        "# of Ratings = 2": `${location["# of Ratings =2"]} [${location["% of Ratings = 2"]}%]`,
        "nonPayment Reported": `${location["# of nonPaymentReportsNum"]} [${location["% of non payment"]}%]`
      },
      notes: location["notes"],
      phone: location["phone"],
      practiceName: location["practiceName"],
      province: location["province"],
      address: location["address"],
      city: location["city"],
      email: location["email"]
    };
  },
  getHygienistFormatted: state => {
    const hygienist = state.HygienistForDispute[0] || {};
    return {
      stats: {
        ID: hygienist.id,
        Address: `${hygienist.address}, ${hygienist.city}, 
        ${hygienist.province}, ${constants.countryCode[hygienist.country]}`,
        Type: constants.hygienistType[hygienist.type],
        Status: hygienist.Status,
        "Member since": hygienist.registerTimestamp
          ? format(new Date(hygienist.registerTimestamp), "MMMM do yyyy")
          : null,
        "Jobs Completed": hygienist["Jobs Completed"],
        "Star Score": hygienist.starScore,
        "# of Future Shifts": hygienist["Future Jobs"],
        "Upcoming Shift": hygienist["Upcoming Shift"]
          ? formatInTimeZone(hygienist["Upcoming Shift"], "yyyy-MM-dd", "UTC")
          : "-",
        "Blocked Until": hygienist.blockedUntil,
        "# of Cancelled": `${hygienist["# of cancelled shifts"]} [${hygienist["% cancelled"]}%]`,
        "# of Rated Jobs": hygienist["# of Rated Jobs"],
        "# of Ratings = 5": `${hygienist["# of Ratings = 5"]} [${hygienist[
          "% of Ratings = 5"
        ] || 0}%] `,
        "# of Ratings = 2": `${hygienist["# of Ratings =2"]} [${hygienist[
          "% of Ratings = 2"
        ] || 0}%]`,
        "Resume Url": hygienist.resumeUrl,
        "Max Booked": hygienist.maxBooked,
        "Value Gives": hygienist.valueGives,
        // T2-6379: "Keep Status" removed — legacy keep-status is superseded by
        // Fair Fresh Start grandfathering.
        School: hygienist.school,
        "Graduation Year": hygienist.graduationYear,
        "CDHO Number": hygienist.CDHONumber,
        "is Dupe": hygienist.isDupe
      },
      Notes: hygienist.Notes,
      blacklistReason: hygienist.blacklistReason,
      city: hygienist.city,
      email: hygienist.email,
      firstName: hygienist.firstName,
      lastName: hygienist.lastName,
      phone: hygienist.phone,
      province: hygienist.province,
      cancelled: hygienist.cancelled,
      ignoredCancelled: hygienist.ignoredCancelled,
      twoStarJobs: hygienist.twoStarJobs
    };
  },
  getCommentsForHygienist: state => {
    return state.HygienistComments || [];
  },
  getCommentsForLocation: state => {
    return state.LocationComments || [];
  },
  getSinglePaymentIntegrity: state => {
    return state.PaymentIntegrities.filter(item => item.id === state.changedId);
  },
  getPaymentIntegritiesAllowedDates: state => {
    return state.PaymentIntegrities.map(item => item.startDate);
  }
};
